import guestAxios from "@/utils/guestAxios";

export const guestPortalAuthApi = {
  roomStatus: (publicCode) =>
    guestAxios.get(`/api/guest-portal/room/${publicCode}/status`),

  verify: (publicCode, payload) =>
    guestAxios.post(`/api/guest-portal/room/${publicCode}/verify`, payload),

  me: () =>
    guestAxios.get("/api/guest-portal/me", {
      skipGuestAuthRedirect: true,
    }),

  heartbeat: () => guestAxios.post("/api/guest-portal/heartbeat"),

  logout: () => guestAxios.post("/api/guest-portal/logout"),
};
